module.exports = __webpack_public_path__ + "static/media/star.cdeb6d8c.svg";